import { Show } from '@components/Show';
import { Alert, AlertTitle } from '@components/ui/alert';

import { ValidationIcon } from './ValidationIcon';

interface ErrorAlertProps {
  errorMessage: string;
  successMessage: string;
  isError: boolean;
  'data-testid'?: string;
  showAlert: boolean;
}

export default function ErrorAlert({
  errorMessage,
  successMessage,
  isError,
  showAlert,
  'data-testid': testId,
}: ErrorAlertProps) {
  return (
    <Show when={showAlert}>
      <Alert variant={isError ? 'danger' : 'valid'} data-testid={testId}>
        <ValidationIcon type={isError ? 'danger' : 'valid'} />
        <AlertTitle data-testid={testId ? `${testId}-title` : undefined}>
          {isError ? errorMessage : successMessage}
        </AlertTitle>
      </Alert>
    </Show>
  );
}
